import { ReactElement } from 'react';

import { CustomFiltersProps } from './custom-filters.types';

export default function CustomFilters({
  filters,
}: CustomFiltersProps): ReactElement {
  return <>{filters}</>;
}
